// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5097":"747b7a754541d5d0","7433":"7db0e353f13f4efc","8973":"73c7a6574fbb7e54"}[chunkId] + ".css";
};